var _excluded = ["childPosition", "children", "pattern", "containerProps"],
    _excluded2 = ["containerProps", "iconPosition", "iconProps"],
    _excluded3 = ["containerProps", "time", "unit", "unitProps", "customSideLabel"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Div, Input } from '@kizi/core-components';
import React, { useLayoutEffect, useRef, useState } from 'react';
import { IconV2 } from './IconV2';
export var CustomInput = function CustomInput(_ref) {
  var _ref$childPosition = _ref.childPosition,
      childPosition = _ref$childPosition === void 0 ? 'right' : _ref$childPosition,
      children = _ref.children,
      pattern = _ref.pattern,
      _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      inputProps = _objectWithoutProperties(_ref, _excluded);

  var ref = useRef(null);

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      childContainerWidth = _useState2[0],
      setChildContainerWidth = _useState2[1];

  var isChildLeft = childPosition === 'left';
  var childPositionX = {
    right: 0
  };
  var inputPl = 14;

  if (isChildLeft) {
    childPositionX = {
      left: 0
    };
    inputPl = childContainerWidth;
  }

  useLayoutEffect(function () {
    if (ref.current) {
      setChildContainerWidth(window.getComputedStyle(ref.current).width);
    }
  }, [ref]);
  return /*#__PURE__*/React.createElement(Div, _extends({
    display: "flex",
    position: "relative"
  }, containerProps), /*#__PURE__*/React.createElement(Input, _extends({
    height: "100%",
    pattern: pattern,
    width: "100%",
    style: {
      paddingLeft: inputPl
    }
  }, inputProps)), /*#__PURE__*/React.createElement(Div, _extends({
    bottom: 0,
    height: "100%",
    position: "absolute",
    ref: ref,
    top: 0,
    width: "fit-content",
    style: {
      pointerEvents: 'none'
    }
  }, childPositionX), /*#__PURE__*/React.createElement(Div, {
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center"
  }, children)));
};
export var IconInput = function IconInput(_ref2) {
  var containerProps = _ref2.containerProps,
      _ref2$iconPosition = _ref2.iconPosition,
      iconPosition = _ref2$iconPosition === void 0 ? 'right' : _ref2$iconPosition,
      _ref2$iconProps = _ref2.iconProps,
      iconProps = _ref2$iconProps === void 0 ? {
    name: ''
  } : _ref2$iconProps,
      inputProps = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(CustomInput, _extends({
    childPosition: iconPosition,
    containerProps: containerProps
  }, inputProps), iconProps.name !== '' && /*#__PURE__*/React.createElement(IconV2, iconProps));
};
export var UnitInput = function UnitInput(_ref3) {
  var containerProps = _ref3.containerProps,
      time = _ref3.time,
      unit = _ref3.unit,
      unitProps = _ref3.unitProps,
      customSideLabel = _ref3.customSideLabel,
      inputProps = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement(Div, {
    display: "flex",
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(CustomInput, _extends({
    containerProps: containerProps
  }, inputProps), /*#__PURE__*/React.createElement(Div, _extends({
    variant: "unitInput"
  }, unitProps), unit, " ", time && "/ ".concat(time))), customSideLabel && /*#__PURE__*/React.createElement(Div, {
    marginLeft: 5
  }, customSideLabel));
};